module.exports = __webpack_public_path__ + "media/favicon/safari-pinned-tab-54e549f9.svg";